import { Breadcrumbs } from "../components/Breadcrumbs";
import { useSeo } from "../lib/seo";

export default function Terms() {
  useSeo({
    title: "Terms of Use | ProfitMigo",
    description: "The terms governing your use of ProfitMigo's free calculators, including that results are estimates and provided without warranty.",
    path: "/terms",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Terms" }]} />
      <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Terms of Use</h1>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>By using ProfitMigo you agree to these terms.</p>
        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Use of the calculators</h2>
        <p>Our calculators are provided free for informational purposes. You may use them for your own business decisions. You may not scrape, resell or misrepresent the tools as your own.</p>
        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">No warranty</h2>
        <p>Results are estimates based solely on the numbers you enter and on assumptions that may change. We provide the tools "as is" without warranties of accuracy or fitness for a particular purpose.</p>
        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Limitation of liability</h2>
        <p>ProfitMigo is not liable for business decisions made using these tools. Always verify important financial figures independently.</p>
        <h2 className="pt-4 font-display text-2xl font-semibold text-foreground">Changes</h2>
        <p>We may update these terms and will reflect changes on this page.</p>
      </div>
    </div>
  );
}
